// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2119":"362276c6dcf79cb2","7429":"abbeb14e42911291","7635":"cbf61fb478ee06ca"}[chunkId] + ".js";
};